<template>
	<div class="content">
		<div id="my-slider" ref="myslider" :se-min="minThreshold" :se-max="maxThreshold" :se-step="step" :se-min-value="min" :se-max-value="max" class="slider">
			<div class="slider-touch-left">
				<span></span>
			</div>
			<div class="slider-touch-right">
				<span></span>
			</div>
			<div class="slider-line">
				<span></span>
			</div>
		</div>
	</div>
	</template>

	<script>
	import ZbRangeSlider from './ZbRangeSlider'

	export default {
		props: {
			minThreshold: {
				type: Number
			},
			maxThreshold: {
				type: Number
			},
			step: {
				type: Number,
				default: 1
			},
			min: {
				type: Number,
				required: true
			},
			max: {
				type: Number,
				required: true
			}
		},
		data() {
			return {
				instance: undefined,
			}
		},
		mounted() {
			this.instance = new ZbRangeSlider('my-slider'); //componente só pode ser carregado quando as props estiverem prontas
			this.instance.onChange = (min, max) => this.updateValues(min, max);
		},
		destroyed() {

		},
		methods: {
			updateValues(min, max) {
				if(min != this.min)
					this.$emit('updateMin', min)
				else if(max != this.max)
					this.$emit('updateMax', max)
			},
			reset() {
				this.instance.reset();
			}
		}
	}
	</script>

	<style>
	.slider {
		display: block;
		position: relative;
		height: 36px;
		width: 100%;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		-o-user-select: none;
		user-select: none;
	}
	.slider .slider-touch-left,
	.slider .slider-touch-right {
		-webkit-box-sizing: border-box;
		-moz-box-sizing: border-box;
		box-sizing: border-box;
		display: block;
		position: absolute;
		height: 36px;
		width: 36px;
		padding: 6px;
		z-index: 2;
	}
	.slider .slider-touch-left span,
	.slider .slider-touch-right span {
		display: block;
		width: 100%;
		height: 100%;
		background: #f0f0f0;
		border: 1px solid #a4a4a4;
		border-radius: 50%;
	}
	.slider .slider-line {
		-webkit-box-sizing: border-box;
		-moz-box-sizing: border-box;
		box-sizing: border-box;
		position: absolute;
		width: calc(100% - 36px);
		left: 18px;
		top: 16px;
		height: 4px;
		border-radius: 4px;
		background: #f0f0f0;
		z-index: 0;
		overflow: hidden;
	}
	.slider .slider-line span {
		display: block;
		height: 100%;
		width: 0%;
		background: #163247;
	}
	</style>



// WEBPACK FOOTER //
// src/components/make-your-bookings/DoubleRangeSlider.vue